import { z } from 'zod';
export const setupFixSchema = z.enum(['income_charge_mapping', 'general_ledger_connection']);
//# sourceMappingURL=setupBlock.js.map